import SyChip from "./sy-chip";

export default SyChip